const noScroll = require('no-scroll')

const state = {
  menuOpen: false,
  modalOpen: false,
  searchQuery: ''
}

const actions = {
  toggleMenu ({ commit, state }) {
    commit('TOGGLE_MENU')
  },
  closeMenu ({ commit, state }) {
    commit('CLOSE_MENU')
  },
  openModal ({ commit, state }, payload) {
    const { id } = payload
    if ((id && id !== state.modalOpen) || (id && !state.modalOpen)) {
      commit('OPEN_MODAL', id)
    }
  },
  closeModal ({ commit, state }) {
    if (state.modalOpen !== false) {
      commit('CLOSE_MODAL')
    }
  },
  saveSearchQuery ({ commit, state }, query) {
    commit('SAVE_SEARCH_QUERY', query)
  },
  clearSearchQuery ({ commit, state }) {
    commit('CLEAR_SERCH_QUERY')
  }
}

const mutations = {
  TOGGLE_MENU (state) {
    state.menuOpen = !state.menuOpen
    // noScroll causes a weird layout bug on iOS Safari ¯\_(ツ)_/¯
    // state.menuOpen ? noScroll.on() : noScroll.off()
  },
  CLOSE_MENU (state) {
    state.menuOpen = false
    // noScroll.off()
  },
  OPEN_MODAL (state, open) {
    state.modalOpen = open
    noScroll.on()
  },
  CLOSE_MODAL (state) {
    state.modalOpen = false
    noScroll.off()
  },
  SAVE_SEARCH_QUERY (state, query) {
    state.searchQuery = query
  },
  CLEAR_SERCH_QUERY (state) {
    state.searchQuery = ''
  }
}

const getters = {
  menuOpen: state => state.menuOpen
}

const module = {
  state,
  actions,
  mutations,
  getters
}

export default module



// WEBPACK FOOTER //
// ./client/store/ui.js